module.exports = __webpack_public_path__ + "img/med.6502a5a5.png";